export class ClientService {
  constructor(
    private readonly apiUrl: string,
  ) {}

  async getAllClients() {
    try {
      const resultat = await fetch(`${this.apiUrl}/api/clients`, {
        method: "GET",
        cache: "no-store",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }

      return await resultat.json();
    } catch (error) {
      console.error("Erreur lors de la récupération des clients:", error);
      throw error;
    }
  }

  async createClient(client: any) {
    try {
      const resultat = await fetch(`${this.apiUrl}/api/clients`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(client),
      });

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }
    } catch (error) {
      console.error("Erreur lors de la création du client:", error);
      throw error;
    }
  }

  async updateClient(clientId: number, client: any) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/clients/${clientId}/admin`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(client),
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }
    } catch (error) {
      console.error("Erreur lors de la mise à jour du client:", error);
      throw error;
    }
  }

  async deleteClient(clientId: number) {
    try {
      const resultat = await fetch(`${this.apiUrl}/api/clients/${clientId}`, {
        method: "DELETE",
        headers: {
        },
      });

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }
    } catch (error) {
      console.error("Erreur lors de la suppression du client':", error);
      throw error;
    }
  }

  async getCoursesClient(clientId: number) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/courses/client/${clientId}`,
        {
          method: "GET",
          cache: "no-store",
          headers: {
          },
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }

      return await resultat.json();
    } catch (error) {
      console.error("Erreur lors de la mise à jour du client:", error);
      throw error;
    }
  }

  async getClientById(clientId: number) {
    try {
      const resultat = await fetch(`${this.apiUrl}/api/clients/${clientId}`, {
        method: "GET",
        cache: "no-store",
        headers: {
        },
      });

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }

      return resultat.json();
    } catch (error) {
      console.error("Erreur lors de la récupération du client:", error);
      throw error;
    }
  }
}
